import Header from '../Components/Header/Header';
import Footer from '../Components/Footer/Footer';
import Main from '../Components/Main/Main';
import Maincontent from '../Components/Maincontent/Maincontent';


function Home() {
    return (
        <div>
            <Header />
            <Main />
            <Maincontent />
            <Footer />
        </div>
    )
}

export default Home
